<div class="options">
  <app-select-market></app-select-market>
</div>

<div class="controls">
  <div>
    <input type="text" [(ngModel)]="textFilter" (keyup)="filterTeams()">
  </div>
  <div></div>
  <div>
    <button><img src="assets/images/add-button.svg" (click)="openAddTeamModal()"/></button>
  </div>
</div>

<table>
  <tr class="header">
    <th>{{ 'TEAM.ACTIVATED' | translate }}</th>
    <th>{{ 'TEAM.MEMBER' | translate }}</th>
    <th>{{ 'TEAM.FIRST_NAME' | translate }}</th>
    <th>{{ 'TEAM.LAST_NAME' | translate }}</th>
    <th>{{ 'TEAM.LANGUAGE' | translate }}</th>
    <th>{{ 'TEAM.PHONE' | translate }}</th>
    <th>{{ 'TEAM.EMAIL' | translate }}</th>
    <th>{{ 'TEAM.LOCATION' | translate }}</th>
    <th></th>
  </tr>

  @for (team of displayedTeams; track team) {
    <tr>
      <td>
        <input type="checkbox"
          [checked]="team.isActivated"
          (change)="toggleTeamActivation(team)"/>
        @for (role of roles; track role) {
          <img [src]="role.imagePath"
        [ngClass]="{ 'missing-role': team.hasRole(role.rolename) === false, 
          'disabled-role': team.teamMemberId?.toUpperCase().startsWith('EXT') && role.rolename === TEAM_ROLES.REMOTE_SUPERVISION }" 
            (click)="!(team.teamMemberId?.toUpperCase().startsWith('EXT') && role.rolename === TEAM_ROLES.REMOTE_SUPERVISION) && updateRole($event, team, role)"/>
        }
      </td>
      <td>
        @if (!team.teamMemberId?.toUpperCase().startsWith('EXT')) {
          <span>
            {{ team.teamMemberId }}
          </span>
        }
        @if (team.teamMemberId?.toUpperCase().startsWith('EXT')) {
          <span class="badge-external">
            External
          </span>
        }
      </td>
      <td>{{ team.teamMemberFirstName }}</td>
      <td>{{ team.teamMemberName }}</td>
      <td>{{ team.teamMemberLanguage }}</td>
      <td>{{ team.teamMemberCellularPhone }}</td>
      <td>{{ team.teamMemberEmail }}</td>
      <td>{{ team.peoplelocationname }}</td>
      <td>
        <img src="assets/images/edit-icon.svg" (click)="openUpdateTeamModal(team)"/>
        <img src="assets/images/trash-icon.svg" (click)="removeTeam(team)"/>
      </td>
    </tr>
  }
</table>

@if (addingTeam) {
  <app-create-team
    [market]="selectedMarket"
    (closeModal)="closeAddTeamModal($event)">
  </app-create-team>
}

@if (teamToUpdate) {
  <app-update-team
    [team]="teamToUpdate"
    [market]="selectedMarket"
    (closeModal)="closeUpdateTeamModal($event)">
  </app-update-team>
}